const logs = {
    page_title: '監査ログ',
    title: '監査ログ',
    subtitle: 'ユーザーによって行われた認証イベントのログデータを表示します',
    event: 'イベント',
    user: 'ユーザー',
    application: 'アプリケーション',
    time: '時間',
    filter_by: 'フィルター',
    last_1_hour: '過去1時間',
    last_24_hours: '過去24時間',
    last_7_days: '過去7日間',
    last_30_days: '過去30日間',
    custom_range: 'カスタム範囲',
    from: '開始',
    to: '終了',
};
export default Object.freeze(logs);
